import { baseUrl, apiUrl, assetUrl } from '@/config/config'
var axios = require("axios").default;

const localData = (JSON.parse(localStorage.getItem('token')) === null) ? window.location.href = '/' : JSON.parse(localStorage.getItem('token'));
const token = localData.token
export default class Branches {
    async BranchesList(disabled = false) {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}center/list${disabled ? '?disabled=1' : ''}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
               
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async CityList() {
        try {
            const response = await axios.request({
                method: "GET",
                url: `${baseUrl}users/cities`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data
        } catch (error) {
            console.error(error)
            return false
        }
    };

    async enableBranch(data) {
        try {
            const response = await axios.post(`${baseUrl}center/enable`, data, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })
            return response.data;
        } catch (error) {
            console.error(error);
            return false;
        }
    };

    async updatebranches(data) {
        try {
            const response = await axios.post(`${baseUrl}center/update`, data, {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            })

            return response.data;
        } catch (error) {
            console.error(error);
            return false;
        }

    };
}